import { useEffect, useState } from "react";
import { AutocompleteInput } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomFilterSelect from "./CustomFilterSelect";

const FilterAgency = (props: any) => {
  const [agencyList, setAgencyList] = useState([]);
  useEffect(() => {
    const fetchAgencyList = async () => {
      const reqUrl = "agencys/shortList";
      await sendRequest(reqUrl, {
        id: 1,
        data: {
          status: 1, //only active products
        },
      }).then((response) => {
        if (response) {
          setAgencyList(response);
        }
      });
    };
    fetchAgencyList();
  }, []);

  const agencyData = [
    { id: "", name: "Please select" },
    ...agencyList.map((agency: any) => {
      return { id: agency.sName, name: agency.sName };
      // return { id: agency.sName, name: agency.sMarkName };
    }),
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      source="counselor_agency"
      label="Referral Source"
      choices={agencyData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterAgency;
